import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { QuickExitButton } from "./QuickExit";
export function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <div
      data-testid="lang-toggle"
      className="inline-flex items-center rounded-full bg-softpink p-1 text-sm"
    >
      {["en", "ru"].map((l) => (
        <button
          key={l}
          data-testid={`lang-${l}`}
          onClick={() => setLang(l)}
          className={`rounded-full px-3 py-1 font-medium transition-colors ${
            lang === l ? "bg-white text-graphite shadow-soft" : "text-textsec hover:text-graphite"
          }`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  );
}

export function Header({ minimal = false }) {
  const { t } = useLang();
  return (
    <header className="absolute left-0 right-0 top-0 z-[500] flex items-center justify-between px-5 py-4 sm:px-8">
      <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5">
        <span className="flex h-8 w-8 items-center justify-center rounded-full bg-dusty text-white">
          <span className="h-2.5 w-2.5 rounded-full bg-white" />
        </span>
        <span className="hidden text-sm font-semibold tracking-tight text-graphite sm:inline">
          {t("brand")}
        </span>
      </Link>
      <div className="flex items-center gap-3">
        {!minimal && <LangToggle />}
        <QuickExitButton />
      </div>
    </header>
  );
}
